import styles from './index.module.sass'

export const DevModeIndicator = () => {
    return <div className={styles.root}>
        тестовый режим(DEV MODE)
    </div>
}